import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import { Button, Grid2 } from '@mui/material';
import { useCommandsModalContext } from '../CommandsModalContext';

function EnableDisableSection() {
  const { sendCommand } = useCommandsModalContext();
  const handleClearDisable = () => sendCommand('ClearDisableMegapack');
  const handleClickDisable = () => sendCommand('DisableMegapack');

  return (
    <Grid2 container spacing={2}>
      <Grid2
        size={{ xs: 4 }}
        sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}
      >
        <FormattedAlias id='Disable Megapack:' />
      </Grid2>
      <Grid2 size={{ xs: 8 }}>
        <Button variant='contained' onClick={handleClearDisable}>
          <FormattedAlias id='Clear Disable' />
        </Button>
        <Button variant='contained' sx={{ ml: 2 }} onClick={handleClickDisable}>
          <FormattedAlias id='Disable' />
        </Button>
      </Grid2>
    </Grid2>
  );
}

export default EnableDisableSection;
